import React from "react";
import { Modal } from "antd";
import styles from "./style.module.css";

const ReviewsModal = ({ isReviewsModalVisible, handleReviewsCancel, data }) => {
  // Log the data for debugging
  // console.log("ReviewsModal data:", data);

  // Filter out reviews that are null or empty
  const filteredReviews = data
    ?.filter((review) => review?.review)
    .map((review, index) => (
      <div className="" key={index}>
        <div className={`my-2 bg-light pt-2 pl-2 ${styles.border_color}`}>
          <div className="">
            <p className="fs_12 mt-2">
              {review?.review || "No review text available."}
            </p>
          </div>
        </div>
      </div>
    ));

  return (
    <Modal
      title="Reviews"
      footer={null}
      closable
      open={isReviewsModalVisible}
      onCancel={handleReviewsCancel}
      width={650}
      style={{ top: 200 }}
    >
      <div
        className={`row pb-3 overflow-y-scroll ${styles.reviews} ${styles.scrollbar_custom}`}
      >
        {filteredReviews?.length > 0 ? (
          filteredReviews
        ) : (
          <div className="col-12 my-3">
            <p className="fs_12 mt-2">No reviews available.</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ReviewsModal;
